import { createSlice } from "@reduxjs/toolkit";
import { generateFakeTransactionsWithAlerts } from "../../data/transactions";

const { alerts, transactions } = generateFakeTransactionsWithAlerts();

const TransactionSlice:any = createSlice({
    name: "fakeData",
    initialState: {
        alerts,
        transactions,
    },
    reducers: {
        regenerateData(state) {
            const generated = generateFakeTransactionsWithAlerts();
            state.alerts = generated.alerts;
            state.transactions = generated.transactions;
        }
    }
});

export const { regenerateData } = TransactionSlice.actions;
export default TransactionSlice.reducer;
